import * as React from "react";
import { UitkImage } from "uitk-react-images";
import { ImagePlaceholderProps } from "../typings";

export const ImagePlaceholder = (props: ImagePlaceholderProps) => <UitkImage alt={props.alt} placeholderImage={true} />;
